import functions from './functions.js';
import Slider from './Slider.js';
//import lozad from 'lozad';
import inputPopover from "./input-popover.js";
import lozad from 'lozad'
import inputGuests from "./input-guests.js";
import { SimpleGuests, SimpleGuestsDefaults } from "./simple-guests.js";

$(function() {

    inputPopover.apply();
    inputGuests.apply();

    window.cart = JSON.parse(functions.getCookie('cart') || '{}');
    window.cartData = JSON.parse(functions.getCookie('cartData') || '{}');
    window.cartData = window.cart && window.cart.length > 0 ? window.cartData : JSON.parse('{}');

    //let cartItems = functions.getCookie('cart') ? JSON.parse(functions.getCookie('cart')) : [];
    $('.cart-items-count').text((window.cart && window.cart.length ? window.cart.length : 0));

    document.addEventListener('scroll', e => {
        if(window.scrollY > 20) {
            $('.main-header').addClass('position-fixed active');
        } else {
            $('.main-header').removeClass('position-fixed active');
        }
    });

    $('.simple-guests').each((i, elem) =>
    {
        elem._simpleGuests = new SimpleGuests(elem, {
            btnValueTpl: (adults, children, infants, extras) =>
            {
                return `${adults + (children || 0) + (infants || 0)} ${guestsTranslations[language].guests}${extras ? ', ' + extras + ' ' + guestsTranslations[language].infants : ''}`;
            }
        });
    });

    /*if(! functions.getCookie('displayBenefitsModal')) {
        setTimeout(() => {
            $('#benefitsModal').modal('show');
            functions.setCookie('displayBenefitsModal', true, 1);
        }, 10000);
    }*/

    // global datepicker init with automatic "dateTo" set if provided
    // resolves once the pickers exist, so late form fills can wait on it
    if ($('.datepicker').length) {
        window.datepickersReady = import(/* webpackChunkName: "datepicker" */ './datepicker.js')
            .then(m => m.default());
    }

    
    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-header [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if ( href && href != '#' ) {
            href = href.split('?')[0].replace(/\/$/, '');
            if ( path === href ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    /* gallery */
    const lg = {};
    // lightgallery is only fetched once someone actually opens a gallery
    let lgLoading;
    const loadLightGallery = () => lgLoading
        || (lgLoading = import(/* webpackChunkName: "lightgallery" */ './gallery.js'));

    window.showGallery = (index, id) => loadLightGallery().then(() => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    });
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    /* end gallery */

    // mobile menu handling
    (() => {
        const $header = $('.main-header');
        const $collapser = $header.find('.navbar-collapse'); // $('#main-menu');

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                document.body.classList.add('modal-transition');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                document.body.classList.remove('modal-transition');
            });

        // click on "overlay" closes menu
        $header.find('.header-overlay').on('click', () => {
            $collapser.collapse('hide');
        });
    })();


    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    $(document).on('click', '.excursion-info-card', e => {
        let target = $(e.currentTarget).attr('data-target');

        $('.itinerary-btn[data-target="' + target + '"]').each((i, elem) => {
            $(elem).trigger('click');
        })
    })
    
   
    // button checkbox
    $('.btn-checkbox').on('click', e => {
        let input = $(e.target).prev()[0];
        input.checked = !input.checked;
    });

    $('#cookie-bar-accept').on('click', function (e) {
        functions.setCookie('cookie_usage', 'accepted');
        $("#cookie-bar").addClass('d-none');
    });


    /*$('.currency').on('click', function (e) {
        functions.setCookie('currency', $(this).data('currency'));
        location.reload();
    });*/

    $('.currency-change').on('click', function (e) {
        functions.setCookie('currencyIdTo', e.target.id);
        location.reload();
    });

    $(window).on('load', () => {
        const $body = $('body');
        const checkHeader = () => {
            $body.toggleClass('body-scrolled', window.scrollY > 100);
        }
        let timer = 0;
        $(window).on('scroll', () => {
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(checkHeader);
        });
        checkHeader();
    });

    const videoStella = document.getElementById("video_ship");
    if(videoStella) {
        const observer = new IntersectionObserver(function (intersection) {
            if ( intersection[0].isIntersecting ) {
                videoStella.pause();
            } else {
                if ( videoStella.getAttribute('data-loaded') ) {
                    videoStella.play();
                }
            }
        }, { threshold: 0.5 });
    }
   
    $('[data-video-gallery]').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        loadLightGallery().then(() => {
            $this.lightGallery({
                dynamic: true,
                dynamicEl: [{ src: $this.attr('data-src') }],
                videoMaxWidth: '75%',
                counter: false,
                addClass: 'video-gallery'
            });
        });
    });

    $('[id^=home-list-slider]').each(function () {
        new Slider(this, {
            fade: true,
            loop: true,
            drag: true,
            // autoplay: 6000,
            arrows: true,
            slides: {
                perView: 3,
                spacing: 0
            },
        });
    });

    window.showmoreobserver = lozad('.show-more', {
        rootMargin: '200px 200px',
        loaded: elem =>
        {
            $(elem).triggerHandler('lozadLoaded');
            let $showMore = $(elem);

            let height = $showMore.attr('data-height');
            if ($showMore.find('.show-more-content').outerHeight() < height)
            {
                $showMore.addClass('removeBefore');
                $showMore.next('.show-more-expand').remove();
                return;
            }

            let $breakpoint = $showMore.find('.show-more-breakpoint');
            if (height)
            {
                $showMore.css('max-height', +height);
            }
            else if ($breakpoint.length)
            {
                $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
            }
            else
            {
                let $maxHeight = functions.isMobile() ?
                    ($showMore.outerHeight() * 0.15) :
                    ($showMore.outerHeight() * 0.3);

                $showMore.css('max-height', $maxHeight);
            }
            $showMore.on('click', e =>
            {
                e.stopPropagation();
                let $prevSibling = $(e.currentTarget);
                let $maxHeight
                if ($prevSibling.hasClass('removeBefore'))
                {
                    let height = $prevSibling.attr('data-height');
                    let $breakpoint = $prevSibling.find('.show-more-breakpoint');
                    if (height)
                    {
                        $maxHeight = +height;
                    }
                    else if ($breakpoint.length)
                    {
                        $maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
                    }
                    else
                    {
                        $maxHeight = functions.isMobile() ?
                            ($prevSibling.outerHeight() * 0.15) :
                            ($prevSibling.outerHeight() * 0.3);
                    }
                    $prevSibling.css('max-height', $maxHeight);
                    $prevSibling.removeClass('removeBefore');
                    if ($prevSibling.hasClass('show-more-scroll'))
                    {
                        $('html, body').stop().animate({
                            scrollTop: $prevSibling.offset().top + $maxHeight - $(e.target).outerHeight(),
                        }, 0, 'linear');
                    }
                }
                else
                {
                    let $content = $prevSibling.find('.show-more-content');
                    $prevSibling.css('max-height', $content.outerHeight());
                    $prevSibling.addClass('removeBefore');
                }

                $prevSibling.toggleClass('closed');
            })
        }
    });
    window.showmoreobserver.observe();

    setTimeout(() => {
        $('[id^=list-slider]').each(function () {
                new Slider(this, {
                    fade: true,
                    loop: true,
                    arrows: true
                });
            });
    }, 0);


    $('.available[data-href]').on('click', function(e) {
        e.preventDefault();

        const $target = $(e.currentTarget);
        let href = $target.attr('data-href');

        window.open(href);
    })

    

}); 